import axios from 'axios'
import {
  MessageBox,
  Message
} from 'element-ui'
import store from '@/store'
import {
  getToken
} from '@/utils/auth'
import Cookies from "js-cookie";
// create an axios instance
const service = axios.create({
  baseURL: '/proxy/merchant',
  timeout: 1000 * 20 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // if (store.getters.token) {
    config.headers['token'] = getToken()
    // }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // blob 类型（导出下载）不做 code 判断，直接返回原始 response
    if (response.config.responseType === 'blob' || response.data instanceof Blob) {
      return response
    }
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res.code == 1006) {
      return res
    }
    if (res.code !== 20000) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
      }
      const num = 0
      if (res.message === '密码错误') {
        if (Cookies.get('num')) {
          const i = Cookies.get('num')
          Cookies.set('num', Number(i) + 1)
        } else {
          Cookies.set('num', Number(num) + 1)
        }
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      Cookies.remove('num')
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
